/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const ROUND_RESULT_MESSAGES = {
    TIMEOUT: () => (
        <FormattedMessage
            id='post_battle.round_result.messages.timeout'
            defaultMessage='Время боя истекло'
        />
    ),
    TECHNICAL_VICTORY: () => (
        <FormattedMessage
            id='post_battle.round_result.messages.technical.victory'
            defaultMessage='Противник не вышел в бой'
        />
    ),
    TECHNICAL_DEFEAT: () => (
        <FormattedMessage
            id='post_battle.round_result.messages.technical.defeat'
            defaultMessage='Союзники не вышли в бой'
        />
    ),
    EXTERMINATION_VICTORY: time => (
        <FormattedMessage
            id='post_battle.round_result.messages.extermination.victory'
            defaultMessage='Вся техника противника уничтожена за {time}'
            values={{ time }}
        />
    ),
    EXTERMINATION_DEFEAT: time => (
        <FormattedMessage
            id='post_battle.round_result.messages.extermination.defeat'
            defaultMessage='Вся техника союзников уничтожена за {time}'
            values={{ time }}
        />
    ),
    EXTERMINATION_DRAW: time => (
        <FormattedMessage
            id='post_battle.round_result.messages.extermination.draw'
            defaultMessage='Вся техника уничтожена за {time}'
            values={{ time }}
        />
    ),
    BASE_VICTORY: time => (
        <FormattedMessage
            id='post_battle.round_result.messages.base.victory'
            defaultMessage='Союзники захватили базу за {time}'
            values={{ time }}
        />
    ),
    BASE_DEFEAT: time => (
        <FormattedMessage
            id='post_battle.round_result.messages.base.defeat'
            defaultMessage='Противник захватил базу за {time}'
            values={{ time }}
        />
    ),
    BASE_DRAW: time => (
        <FormattedMessage
            id='post_battle.round_result.messages.base.draw'
            defaultMessage='Обе базы захвачены за {time}'
            values={{ time }}
        />
    ),
}

export function getMessageForControllingPointsCount(points) {
    const message_by_points = [(
        <FormattedMessage
            id='postbattle_screen_header_messages.defeat'
            key={0}
            defaultMessage='Цитадель союзников захвачена'
        />
    ), (
        <FormattedMessage
            id='postbattle_screen_header_messages.only_command_center_under_control'
            key={1}
            defaultMessage='Оба рубежа союзников захвачены'
        />
    ), (
        <FormattedMessage
            id='postbattle_screen_header_messages.first_line_under_control'
            key={2}
            defaultMessage='Передовой рубеж союзников захвачен'
        />
    ), (
        <FormattedMessage
            id='postbattle_screen_header_messages.draw'
            key={3}
            defaultMessage='Оба клана защитили свои рубежи'
        />
    ), (
        <FormattedMessage
            id='postbattle_screen_header_messages.enemy_first_line_capruted'
            key={4}
            defaultMessage='Передовой рубеж противника захвачен'
        />
    ), (
        <FormattedMessage
            id='postbattle_screen_header_messages.enemy_second_line_capruted'
            key={5}
            defaultMessage='Оба рубежа противника захвачены'
        />
    ), (
        <FormattedMessage
            id='postbattle_screen_header_messages.enemy_command_center_capruted'
            key={6}
            defaultMessage='Цитадель противника захвачена'
        />
    )]

    return message_by_points[points]
}

export const NAME_BY_DIRECTION = {
    A: (
        <FormattedMessage
            id='postbattle_screen_subtitle.battle.direction_a'
            defaultMessage={'Северный'}
        />
    ),
    B: (
        <FormattedMessage
            id='postbattle_screen_subtitle.battle.direction_b'
            defaultMessage={'Восточный'}
        />
    ),
    C: (
        <FormattedMessage
            id='postbattle_screen_subtitle.battle.direction_c'
            defaultMessage={'Южный'}
        />
    ),
    D: (
        <FormattedMessage
            id='postbattle_screen_subtitle.battle.direction_d'
            defaultMessage={'Западный'}
        />
    ),
}

export const NAME_BY_DIRECTION_SPELLED = {
    A: (
        <FormattedMessage
            id='postbattle_screen_subtitle.battle.direction_a_spelled'
            defaultMessage={'Северного'}
        />
    ),
    B: (
        <FormattedMessage
            id='postbattle_screen_subtitle.battle.direction_b_spelled'
            defaultMessage={'Восточного'}
        />
    ),
    C: (
        <FormattedMessage
            id='postbattle_screen_subtitle.battle.direction_c_spelled'
            defaultMessage={'Южного'}
        />
    ),
    D: (
        <FormattedMessage
            id='postbattle_screen_subtitle.battle.direction_d_spelled'
            defaultMessage={'Западного'}
        />
    ),
}


// WEBPACK FOOTER //
// ./helpers/i18n/fort_battles.jsx